import { css } from "@linaria/core";

import {
  MOBILE_BREAKPOINT_PX,
  TABLET_BREAKPOINT_PX,
} from "../../../../styles/constants";
import { breakpointDownMixin } from "../../../../styles/mixins/breakpoints";
import { outlineMixin } from "../../../../styles/mixins/outline";
import { buttonReset } from "../../../../styles/resets";
import {
  colorProps,
  easingProps,
  headerPaddingProp,
  figtreeProps,
} from "../../../../styles/variables";

export const headerHeightProp = "--header--height";

export const headerSlideDurationMs = 200;

export const headerCls = css`
  position: fixed;
  inset: 0 0 auto;
  z-index: 1001;

  box-shadow: 0 0 10px rgb(var(${colorProps.shadow}), 0.2);
  background: rgb(var(${colorProps.bg}));

  opacity: 0;
  transform: translateY(-100%);

  :global(:root) {
    ${headerHeightProp}: 6rem;
  }

  &-enter {
    &-active {
      opacity: 1;
      transform: translateY(0);
      transition:
        opacity ${headerSlideDurationMs}ms linear,
        transform ${headerSlideDurationMs}ms var(${easingProps.outCubic});
    }

    &-done {
      opacity: 1;
      transform: unset;
    }
  }
`;

export const containerCls = css`
  position: relative;
  z-index: 2;

  padding: 0 var(${headerPaddingProp});

  height: 6rem;

  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const logoWrapperCls = css`
  ${outlineMixin({ offset: "0.8rem" })};

  min-width: 0;

  display: flex;
  flex-grow: 1;
  flex-basis: 0;
  align-items: center;

  cursor: pointer;

  @media screen and (${breakpointDownMixin(TABLET_BREAKPOINT_PX)}) {
    margin-top: 1px;
    font-size: 1.8rem;
  }
`;

export const logoCls = css`
  margin-right: 1.5rem;
  height: 2.8rem;
  flex-shrink: 0;
`;

export const headingCls = css`
  margin: 0;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  font-family: var(${figtreeProps.fontFamily});
  font-weight: var(${figtreeProps.medium});
  font-size: 2rem;
  line-height: 2.1rem;
  text-transform: uppercase;

  @media screen and (${breakpointDownMixin(MOBILE_BREAKPOINT_PX)}) {
    /**
     * intentionally fixate size of the heading on mobile devices; we don't have
     * enough space to allow it to grow on smaller devices in case the user has
     * asked for zoomed text size.
     **/
    font-size: 18px;

    /**
     * unless min css calculation is supported, in that case based  the size of
     * the font directly on the available space, then allow dynamic downscaling
     * of the font to fit the user's device.
     */
    font-size: min(calc((100vw - 12.5rem) / 14), 1.8rem);
  }
`;

export const rightSectionCls = css`
  height: 100%;
  display: flex;
`;

export const userButtonCls = css`
  ${buttonReset};
  ${outlineMixin({
    targetSelector: "& > span",
    borderRadius: "50%",
    offset: "1rem",
  })};

  position: relative;
  z-index: 1;

  margin: 0 -2rem;
  padding: 0 2rem;

  /**
   * extend the clickable area so that the user can easily interact with the
   * button without having to manage to click exactly inside the icon
   */
  display: flex;
  align-items: center;
  height: 100%;

  /**
   * material design style hover with fade-out of inactive elements once user
   * moves the cursor on top of the navigation bar, and then highlight of the
   * specific entry once hovered
   */
  transition: opacity 0.1s linear;

  .${rightSectionCls}:hover & {
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }

  & svg {
    height: 2rem;
  }
`;
